let firebaseConfig = {
    apiKey: "AIzaSyAaecI-W75B7ot-z2T1lMPZi4RrNt_lH3E",
    authDomain: "sommerce-develop.firebaseapp.com",
    databaseURL: "https://sommerce-develop.firebaseio.com",
    projectId: "sommerce-develop",
    storageBucket: "sommerce-develop.appspot.com",
    messagingSenderId: "512854204757",
    appId: "1:512854204757:web:1e8a98d27bbd77243b4fdc",
    measurementId: "G-WPPVQLE33X"
  };
  if(process.env.REACT_APP_FIREBASE_PROD === "YES"){
    firebaseConfig = {
      apiKey: "AIzaSyDrptWb4A0FB3hwB-ukeHkIi4YQrcsLM44",
      authDomain: "tokorame-prod.firebaseapp.com",
      projectId: "tokorame-prod",
      storageBucket: "tokorame-prod.appspot.com",
      messagingSenderId: "323491252299",
      appId: "1:323491252299:web:e48539c198ea73ac7165ce",
      measurementId: "G-76GH48XQHR",
    };
  }
export default firebaseConfig